module.exports = "/packs/images/svg/facilities/diving~a3cde63190831947b78f6f24f95368f2.svg";